import { StorefrontIcon } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const GroupChipLabel = ({ group }) => (
  <Styles.Container>
    <Text tag="span" type="bodySBold">
      {group.name}:
    </Text>
    {group.storeNames.map((storeName, index) => (
      <Styles.StoreItem key={storeName}>
        {index > 0 && <Styles.Separator>|</Styles.Separator>}
        <StorefrontIcon size={12} weight="regular" />
        {storeName}
      </Styles.StoreItem>
    ))}
  </Styles.Container>
)

export default GroupChipLabel
